module.exports = __webpack_public_path__ + "img/plus.2d9a8aea.svg";